import { Box, FormLabel } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import MainModel from "../../../components/Models/main-model";
import { closeChooseStudentGroup } from "../../../modules/admin-modules/models/Actions";
import { getTeacherCoursesRequest } from "../../../modules/public/publicData/Actions";
import { enrolledCourseRequest } from "../../../modules/students-modules/courses/Actions";
import { getAllGroupsRequest } from "../../../modules/students-modules/groups/Actions";

const ChooseGroup = ({ selectedData }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.model.isOpen35);
  const { id } = useParams();

  const [groupId, setGroupeId] = useState();
  const userData = useSelector((state) => state.user.userData);
  const isLoading = useSelector((state) => state.courses.isLoading);

  const { groups } = useSelector((state) => state.studentGroups);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  useEffect(() => {
    if (selectedData?.id) dispatch(getAllGroupsRequest(selectedData?.id));
  }, [selectedData?.id]);
  const handelChooseGroup = () => {
    dispatch(
      enrolledCourseRequest({
        student_group_id: groupId,
        student_id: userData?.id,
        course_id: selectedData?.id,
        success: () => {
          dispatch(closeChooseStudentGroup());
          dispatch(getTeacherCoursesRequest(id, userData?.id));
          toast.success("Course Enrolled Successfully , wait for acceptance");
        },
      })
    );
  };

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const header = <Box></Box>;

  const closeFunc = () => {
    dispatch(closeChooseStudentGroup());
  };
  return (
    <MainModel
      header={header}
      closeFunc={closeFunc}
      openVar={isOpen}
      buttonTitle={"Save"}
      buttonFunc={handelChooseGroup}
      size="md"
      isLoading={isLoading}
      extraButtons={undefined}
      closeButtonTitle="Cancel"
    >
      <Box w="100%" dir>
        <FormLabel>Groups : </FormLabel>
        <Select
          options={groupsOptions}
          onChange={(data) => {
            setGroupeId(data?.value);
          }}
          styles={colourStyles}
          placeholder="choose you group"
        />
      </Box>
    </MainModel>
  );
};

export default ChooseGroup;
